module.exports = __webpack_public_path__ + "img/zhuan.9a1dc4fc.png";